// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  saleId: __t.u64().primaryKey().name("sale_id"),
  listingId: __t.u64().name("listing_id"),
  lotId: __t.u64().name("lot_id"),
  buyer: __t.identity(),
  seller: __t.identity(),
  label: __t.string(),
  priceSov: __t.i64().name("price_sov"),
  qty: __t.u32(),
  at: __t.timestamp(),
});
